export const blockIconsImageLooksOne = (
	<span className='material-symbols-outlined'>looks_one</span>
);
